import { datadogRum } from '@datadog/browser-rum'

export const onRouteChange = (to, from) => {
  // At the init, the path is equal (/ & /) while the name is different (pageName & null)
  // We check the path in order to support the pageView event when going on another link of the same pageName,
  // like going from a product A to a product B (would be the same pageName)
  if (to.path !== from.path) {
    datadogRum.startView(to.name)
  }
}
